var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1,0,0,1,1.3,3.2)",
    d: "M 11.5 3.7 V 7.9 C 11.4 9.2 11.5 9.2 10.3 9.3 H 2.7 C 1.9 9.3 1.9 9.2 1.9 8 V 1 C 1.8 0.3 1.9 0.3 2.7 0.3 H 10.2 L 10.2 0.3 C 8.3 1.6 9 2.4 10.9 1.1 L 10.9 1.1 C 12.8 -0.4 12.8 -0.5 11.2 -1.3 L 11.2 -1.3 C 8.7 -2.4 8.1 -1.3 10.3 -0.4 L 10.3 -0.5 H 1.9 C 0.7 -0.4 0.8 -0.4 0.8 0.9 V 8 C 0.8 10 0.8 10 2.5 10.1 H 10.4 C 12.2 10 12.2 10 12.2 8 V 3.7 C 11.5 3.7 11.5 3.7 12.3 3.6 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.1 10.4 H 5.1 C 4.4 10.4 4.4 9.8 5.1 9.8 H 8.1 C 8.8 9.8 8.8 10.4 8.1 10.4 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.1 8.6 H 5 C 4.3 8.6 4.3 8 5 8 H 10.1 C 10.8 8 10.7 8.6 10.1 8.6 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.1 6.6 H 5 C 4.3 6.6 4.3 6 5 6 H 10.1 C 10.8 6 10.7 6.6 10.1 6.6 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublish);
export default __webpack_public_path__ + "static/media/publish.7239de0b.svg";
export { ForwardRef as ReactComponent };